export default function safeParse<T = any>(input: string): T | undefined {
  try {
    return JSON.parse(input);
  } catch (ex) {
    return undefined;
  }
}
